import React from "react";
import _ from "lodash";
import RadioControl from "components/common/RadioControl";
import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import { NetworkAPI } from "apis";
import { MESSAGE } from "constants/Message";
import { NETWORK_STATUS_ENUM, networkStatus } from "constants/NetworkStatus";

class UpdateNetworkStatusModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      options: [
        NETWORK_STATUS_ENUM[networkStatus.RUNNING],
        NETWORK_STATUS_ENUM[networkStatus.PAUSED],
        NETWORK_STATUS_ENUM[networkStatus.TERMINATED],
      ].map((status) => ({
        label: _.startCase(_.toLower(status)),
        value: status,
      })),
      selectedOption: null,
      msg: [],
    };

    this.handleConfirm = this.handleConfirm.bind(this);
  }

  componentDidMount() {
    const { network } = this.props;

    const status = _.get(network, "status", null);
    this.setState({ selectedOption: status });
  }

  async handleConfirm() {
    const { network, updateData } = this.props;
    const { selectedOption } = this.state;

    this.setState({ isLoading: true, msg: [] });
    try {
      const { gamNetwork } = await NetworkAPI.updateNetworkStatus({
        networkId: network.networkId,
        status: selectedOption,
      });

      if (updateData) {
        updateData(gamNetwork);
      }

      this.setState({
        isLoading: false,
        msg: ["Network status updated successfully!", MESSAGE.SUCCESS],
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        msg: [error.toString(), MESSAGE.ERROR],
      });
    }
  }

  render() {
    const { network, handleClose } = this.props;
    const { options, isLoading, msg, selectedOption } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        width="40%"
        title={{
          label: "Update Network Status ",
          highlight: `${network.networkId} ${network.name}`,
        }}
      >
        <div className="mb-6">
          <label className="block font-bold text-gray-800">Status</label>
          <RadioControl
            options={options}
            value={selectedOption}
            onChange={(value) => this.setState({ selectedOption: value })}
          ></RadioControl>
        </div>
        <ModalFooter
          msg={msg}
          confirmText="Update Status"
          isLoading={isLoading}
          onClose={handleClose}
          onCancel={handleClose}
          onConfirm={this.handleConfirm}
        ></ModalFooter>
      </ModalWrapper>
    );
  }
}

export default UpdateNetworkStatusModal;
